import { useOnMount } from "~/common/hooks/useOnMount";
import { useScript } from "~/common/hooks/useScript";
import { type DetailedHTMLProps, type HTMLAttributes } from "react";
import { CURRENT_LANGUAGE } from "~/utils/constants";
import { isWebComponentEnabled, WebcomponentToggle } from "../usePDPTabs";
import useMediaQuery from "~/common/hooks/useMediaQuery";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "~/utils/screenSizes";
import classNames from "classnames";
import { NumberFormatter } from "~/utils/NumberFormatter";

interface Props {
  greaseAppUrl: string;
  designation?: string;
}

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace

  namespace JSX {
    interface IntrinsicElements {
      "grease-app": DetailedHTMLProps<
        HTMLAttributes<HTMLElement> & {
          bearing?: string;
          language?: string;
          separator?: "point" | "comma";
        },
        HTMLElement
      >;
    }
  }
}

const IFRAME_ID = "greaseAppIframe";

export const GreaseAppTab = (props: Props) => {
  const { greaseAppUrl, designation } = props;
  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);

  useOnMount(() => {
    (window as any).iFrameResize({ log: false }, `#${IFRAME_ID}`);
  });

  useScript(window.SCHA.urls.greaseAppWebComponent);

  return (
    <div
      className={classNames("scha__ignore-margins", {
        "w-100": !isDesktop,
      })}
    >
      {isWebComponentEnabled(WebcomponentToggle.GREASE_APP) ? (
        <grease-app
          bearing={designation}
          language={CURRENT_LANGUAGE}
          separator={NumberFormatter.getDecimalSeparatorName()}
        />
      ) : (
        <iframe className="scha__pdp-iframe" id={IFRAME_ID} src={greaseAppUrl} scrolling="yes" />
      )}
    </div>
  );
};
